import React from "react";

// Collapsed sidebar logo — just the "S" cell from the ctrl+s wordmark.
// Used when the side navigation is in its narrow state. Same color
// strategy as the wordmark variants (currentColor driven by the wrapper's
// text-* utility, so dark-mode inversion is automatic).
const CollapsedLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    className={`collapsed-logo h-[32px] text-black dark:text-zinc-100 ${className}`}
  >
    <g fill="none" fillRule="evenodd">
      <rect stroke="currentColor" strokeWidth="2" x="1" y="1" width="50" height="50" rx="5" />
      <path
        fill="currentColor"
        d="M22.382 32.037c.875.616 2.01.923 3.403.923 1.242 0 2.25-.223 3.024-.67.773-.445 1.16-1.043 1.16-1.79 0-.628-.178-1.099-.533-1.412-.354-.314-.83-.537-1.426-.67-.596-.132-1.515-.27-2.757-.416-1.698-.193-3.1-.452-4.203-.778-1.102-.325-1.99-.844-2.661-1.556-.672-.712-1.008-1.67-1.008-2.877 0-1.134.336-2.142 1.008-3.022.671-.88 1.597-1.562 2.776-2.045 1.18-.483 2.516-.724 4.012-.724 2.46 0 4.456.519 5.99 1.556 1.534 1.038 2.364 2.498 2.491 4.38h-3.993c-.102-.845-.545-1.539-1.331-2.081-.786-.543-1.775-.814-2.967-.814-1.191 0-2.156.217-2.89.651-.735.434-1.103 1.025-1.103 1.773 0 .555.184.971.551 1.248.368.278.83.471 1.388.58.558.108 1.458.235 2.7.38 1.674.169 3.081.428 4.222.778 1.142.35 2.054.904 2.739 1.665.684.76 1.026 1.791 1.026 3.094 0 1.158-.355 2.177-1.065 3.058-.71.88-1.686 1.556-2.928 2.026-1.242.471-2.636.706-4.184.706-2.612 0-4.722-.56-6.332-1.682-1.61-1.123-2.44-2.673-2.491-4.65h3.956c.076.964.551 1.754 1.426 2.37"
      />
    </g>
  </svg>
);

export default CollapsedLogo;
